import React, { memo, forwardRef } from "react";
const SvgCapitalKappa = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M21.552 22.168c.32.32.48.664.48 1.032 0 .32-.112.6-.336.84-.224.224-.512.336-.864.336-.368 0-.712-.168-1.032-.504L11.424 15.4h-.048v7.632c0 .496-.128.848-.384 1.056-.256.192-.52.288-.792.288-.288 0-.56-.096-.816-.288-.256-.208-.384-.56-.384-1.056V8.344c0-.496.128-.84.384-1.032C9.64 7.104 9.912 7 10.2 7c.272 0 .536.104.792.312.256.192.384.536.384 1.032v6.336h.048l7.968-7.224c.352-.304.68-.456.984-.456.32 0 .584.104.792.312.224.192.336.44.336.744 0 .384-.168.72-.504 1.008l-6.912 5.904 7.464 7.2z"
      />
    </svg>
  );
});
SvgCapitalKappa.displayName = "SvgCapitalKappa";
const MemoForwardRef = memo(SvgCapitalKappa);
export default MemoForwardRef;
